import type { ViewerState } from "./types";
import { userAuthInitialState } from "./authSlice";
import { connectionInitialState } from "./connectionSlice";
import { guiInitialState } from "./guiSlice";
import { sceneInitialState } from "./sceneSlice";
import { selectionInitialState } from "./selectionSlice";
import { modulesInitialState } from "./modulesSlice";
import { noticesInitialState } from "./noticesSlice";
import { selectedModuleInitialState } from "./selectedModuleSlice";
import { connectionPreviewInitialState } from "./connectionPreviewSlice";
import { connectShelfInitialState } from "./connectShelfSlice";
import { instancesInitialState } from "./instancesSlice";
import { ikInitialState } from "./ikSlice";
import { jointsInitialState } from "./jointsSlice";
import { editLinksInitialState } from "./editLinksSlice";
import { endCoordsInitialState } from "./endCoordsSlice";
import { highlightingInitialState } from "./highlightingSlice";
import { selfCollisionInitialState } from "./selfCollisionSlice";
import { jointAxesInitialState } from "./jointAxesSlice";
import { moduleAxesInitialState } from "./moduleAxesSlice";
import { endCoordsGizmoInitialState } from "./endCoordsGizmoSlice";
import { jointGroupsInitialState } from "./jointGroupsSlice";
import { jointSettingsInitialState } from "./jointSettingsSlice";
import { locomotionInitialState } from "./locomotionSlice";
import { mimicSettingsInitialState } from "./mimicSettingsSlice";
import { jointAxisVisualizationInitialState } from "./jointAxisVisualizationSlice";
import { chainJointsInitialState } from "./chainJointsSlice";
import { dragInitialState } from "./dragSlice";

export const initialViewerState: ViewerState = {
  ...userAuthInitialState,
  ...connectionInitialState,
  ...guiInitialState,
  ...sceneInitialState,
  ...selectionInitialState,
  ...modulesInitialState,
  ...noticesInitialState,
  ...selectedModuleInitialState,
  ...connectionPreviewInitialState,
  ...connectShelfInitialState,
  ...instancesInitialState,
  ...ikInitialState,
  ...jointsInitialState,
  ...editLinksInitialState,
  ...endCoordsInitialState,
  ...highlightingInitialState,
  ...selfCollisionInitialState,
  ...jointAxesInitialState,
  ...moduleAxesInitialState,
  ...endCoordsGizmoInitialState,
  ...jointGroupsInitialState,
  ...jointSettingsInitialState,
  ...locomotionInitialState,
  ...mimicSettingsInitialState,
  ...jointAxisVisualizationInitialState,
  ...chainJointsInitialState,
  ...dragInitialState,
};
